module.exports = __webpack_public_path__ + "assets/img/hjbg1.e23a7e7a.png";